export default "__VITE_ASSET__DElfKXhF__"